import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { useCurrentActor } from 'components/contexts/CurrentActor';

export default function ArchiveProjectModal({
  isArchiveProjectDisabled = false,
  onArchiveProjectSubmit,
  onClose,
  project,
}) {
  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton
            color='blue'
            disabled={isArchiveProjectDisabled}
            onClick={() => onArchiveProjectSubmit({ id: project.id })}
          >
            {i18nTShared('archiveName', {
              interpolation: { escapeValue: false },
              name: singularRAMSName,
            })}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-6'>
        <h2 className='modalbox-header__title truncated-text-container tw-text-xl tw-font-semibold tw-text-grey-900'>
          {i18nTShared('archiveName', {
            interpolation: { escapeValue: false },
            name: project.attributes.name,
          })}
        </h2>
      </div>
    </ModalBox>
  );
}

ArchiveProjectModal.propTypes = {
  isArchiveProjectDisabled: PropTypes.bool,
  onArchiveProjectSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired,
};
